import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";

// css
import styles from "./mainLayout.module.scss";

import Sidebar from "../../components/Header/sidebar/Sidebar";
import InactiveSessionLogoutPopup from "components/Modals/InactiveSessionLogoutPopup/Index";
import { useSelector } from "react-redux";
import { useGetProfileQuery } from "store/services/auth";
import { MY_POLICIES } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import useNotificationSocket from "utils/socket/useNotificationSocket";

const MainLayout = () => {
  const userInfo = useSelector((state) => state.auth.userInfo)
  const token = useSelector((state) => state.auth.token);
  useNotificationSocket(token);
  const [sidebar, setSidebar] = useState();
  const location = useLocation();
  const navigate = useNavigate()
  const { data: profile, isLoading: isProfileLoading, isFetching: isProfileFetching } = useGetProfileQuery();

  useEffect(() => {
    if (!userInfo?.is_on_board_complete) {
      navigate('/onboard')
    }

  }, [userInfo])

  if (isProfileLoading || (isProfileFetching && !profile)) {
    return <LoadingIndicator />;
  }

  if (Number(profile?.pending_policies_count) > 0 && location.pathname !== MY_POLICIES) {
    return <Navigate to={MY_POLICIES} replace state={{ policyAcceptanceRequired: true }} />;
  }

  return (
    <>
      <InactiveSessionLogoutPopup />
      <div className={`${styles.mainLayout} d-flex align-items-start`}>
        <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
        <main
          className={`${styles.MainBody} ms-auto MainBody position-relative`}
        >
          <Header sidebar={sidebar} setSidebar={setSidebar} />
          <Outlet />
        </main>
      </div>
    </>
  );
};
export default MainLayout;
